<template>

  <Header />
  
  <div id="stage" class="stage" :class="{ 'open' : menuOpen }">
    <router-view />
  </div>
  
</template>

<script>
import workJson from '@/assets/json/work.json'

import Header from './Header.vue'

export default {
  name: 'App',
  data() {
    return {
      theme: 'white',
      menuOpen: false,
      works: workJson
    }
  },
  components: {
    Header,
  },
  methods: {
    menuToggle() {
      this.menuOpen = !this.menuOpen;
    }
  },
  watch: {
    $route() {
      this.theme = 'white'
      this.menuOpen = false
      window.scrollTo(0,0)
    }
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/app.scss';
</style>
